import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import Button from "../../components/Button";
import DisputeHistoryTable from "../../components/Dispute/DisputeHistoryTable";
import DisputeTable from "../../components/Dispute/DisputeTable";
import RejectModal from "../../components/Dispute/RejectModal";
import ReportDownload from "../../components/Dispute/ReportDownload";
import Modal from "../../components/Modal";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import { ToastMessage } from "../../components/ToastMessage";
import { Colors, Text } from "../../config/Constants";
import { getFormattedRefundList } from "../../helper";
import {
  getAllRefundList,
  getPendingRefundList,
  processRefund,
} from "../../services/disputeService";
const downloadIcon = require("../../assets/images/download-icon.png");

const Dispute = () => {
  const [approveConfirmationModal, setApproveConfirmationModal] =
    useState(false);
  const [rejectConfirmationModal, setRejectConfirmationModal] = useState(false);
  const [comment, setComment] = useState("");
  const [pendingDispute, setPendingDispute] = useState([]);
  const [allDispute, setAllDispute] = useState([]);
  const [dateModal, setOpenModal] = useState(false);
  const [dispute, setDispute] = useState({
    id: "",
    outlet: "",
    customer: "",
    date_time: "",
    amount: 0,
    contact: "",
    reason: "",
    comment: "",
    status: "",
  });

  useEffect(() => {
    fetchPendingRefundList();
    fetchAllRefundList();
  }, []);

  const handleRejectCall = async () => {
    let postData = {
      refundId: dispute.id,
      approval: 0,
      comments: comment,
    };
    try {
      await processRefund(postData);
      setRejectConfirmationModal(false);
      fetchPendingRefundList();
      fetchAllRefundList();
    } catch (error: any) {
      toast.error(<ToastMessage message={error.message} />, {
        hideProgressBar: true,
      });
    }
  };

  const handleApproveCall = async () => {
    let postData = {
      refundId: dispute.id,
      approval: 1,
      comments: "Approved",
    };
    try {
      await processRefund(postData);
      setApproveConfirmationModal(false);
      fetchPendingRefundList();
      fetchAllRefundList();
    } catch (error: any) {
      toast.error(<ToastMessage message={error.message} />, {
        hideProgressBar: true,
      });
    }
  };

  const fetchPendingRefundList = async () => {
    try {
      let { data } = await getPendingRefundList();
      if (data.code === 200) {
        let formattedOutlets = getFormattedRefundList(data?.data);
        setPendingDispute(formattedOutlets);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAllRefundList = async () => {
    try {
      let { data } = await getAllRefundList();
      if (data.code === 200) {
        let formattedOutlets = getFormattedRefundList(data?.data);
        setAllDispute(formattedOutlets);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleApprove = (data: any) => {
    setDispute(data);
    setApproveConfirmationModal(true);
  };

  const handleReject = (data: any) => {
    setDispute(data);
    setComment("");
    setRejectConfirmationModal(true);
  };

  return (
    <>
      <DisputePageContainer>
        <DisputeContainer>
          <DisputeSectionWrapper>
            <StyledPageHeader>{Text.disputeHeader}</StyledPageHeader>
            <DisputeTable
              isTableDataLoading={false}
              data={pendingDispute}
              onApprove={handleApprove}
              onReject={handleReject}
            />
          </DisputeSectionWrapper>
          <DisputeHistorySectionWrapper>
            <StyledPageHeader>
              <div>{Text.disputeHistoryHeader}</div>
              <ButtonWrapperDownload>
                <div>
                  <Button
                    label={Text.downloadButtonText}
                    variant="filled"
                    color={Colors.solidRed}
                    size="medium"
                    isRounded={true}
                    onClick={() => setOpenModal(true)}
                    endIcon={downloadIcon}
                  />
                </div>
              </ButtonWrapperDownload>
            </StyledPageHeader>
            <TableWrapper>
              <DisputeHistoryTable
                isTableDataLoading={false}
                data={allDispute}
              />
            </TableWrapper>
          </DisputeHistorySectionWrapper>
        </DisputeContainer>
      </DisputePageContainer>
      {approveConfirmationModal && (
        <ConfirmModal
          heading={Text.disputeResolutionConfirm}
          subHeading={`Are you sure you want to approve ${dispute.outlet} Dispute request for ${dispute.amount} QAR?`}
          button1Label={Text.cancelButton}
          button2Label={Text.yesButton}
          button1Submit={() => setApproveConfirmationModal(false)}
          button2Submit={handleApproveCall}
          setOpenOrClose={() =>
            setApproveConfirmationModal(!approveConfirmationModal)
          }
        />
      )}
      {rejectConfirmationModal && (
        <Modal
          setOpenOrClose={setRejectConfirmationModal}
          variant="none"
          width="21.2rem"
        >
          <RejectModal
            setOpenOrClose={setRejectConfirmationModal}
            onRejectCall={handleRejectCall}
            onCommentChange={(e: any) => setComment(e.target.value)}
            comment={comment}
          />
        </Modal>
      )}
      {dateModal && (
        <Modal setOpenOrClose={setOpenModal} variant={"none"} width="21.2rem">
          <ReportDownload setOpenOrClose={setOpenModal} />
        </Modal>
      )}
    </>
  );
};

const TableWrapper = styled.div``;
const DisputeSectionWrapper = styled.div``;
const DisputeHistorySectionWrapper = styled.div`
  margin-top: 5rem;
`;
const ButtonWrapperDownload = styled.div`
  display: flex;
  justify-content: flex-end;
  > div {
    width: fit-content;
    > div > button {
      padding-right: 1rem;
      padding-left: 1rem;
    }
  }
  @media only screen and (max-width: 768px) {
    > div {
      width: 100%;
    }
  }
`;

const DisputePageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  @media only screen and (max-width: 768px) {
    gap: 2rem;
  }
`;

const DisputeContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  font-weight: 500;
  line-height: 1.75rem;
  padding-bottom: 1.25rem;
  color: ${Colors.black};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 768px) {
    padding: 1rem;
    padding-bottom: 0;
    font-size: 1rem;
  }
`;

export default Dispute;
